module.exports = __webpack_public_path__ + "img/zend-framework.e3f18f1c.svg";